import React, { useState } from "react";
import jwt_decode from "jwt-decode";
import { logout } from "../../../allocator-portal/src/services/user";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import { Alert } from "../Alert";
import { NoDataFound } from "@public/ui-toolkit";
const LayoutWrapper = (props) => {
  const { alerts, totalMessages } = props;
  const history = useHistory();
  const [notificationLength, setNotificationLength] = useState(
    alerts?.items?.length
  );

  const getUserDetails = () => {
    var token = sessionStorage.getItem("token") ?? localStorage.getItem("token");
    if (token !== null) {
      return jwt_decode(token);
    }
    return {};
  };
  var date = new Date();
  let year = date.getFullYear();
  const alertNavigation = [
    {
      key: 0,
      value: "/fund?fundId=",
    },
    {
      key: 1,
      value: "/postfeed",
    },
    {
      key: 2,
      value: "/management",
    },
    {
      key: 3,
      value: "/Chat?roomId=",
    },
    {
      key: 4,
      value: "/Chat?roomId=",
    },
    {
      key: 5,
      value: "/fund?fundId=",
    },
    {
      key: 6,
      value: "/meeting?appointmentId=",
    },
    {
      key: 7,
      value: "/fund?fundId=",
    },
    {
      key: 8,
      value: "user-preference",
    },
    {
      key: 9,
      value: "/calendar",
    },
  ];
  const user = getUserDetails();

  const headerDataHedgeFund = [
    {
      key: 1,
      menuItem: "Dashboard",
      link: "/dashboard",
    },
    {
      key: 3,
      menuItem: "Search Allocators",
      link: "/search-allocators",
    },
    {
      key: 4,
      menuItem: "My Funds",
      // link: "/funds",
      link : "/profile?tab=nav-my-fund-list-tab"
    },
    {
      key: 5,
      menuItem: "News Feed",
      link: "/newsfeed",
    },
    {
      key: 7,
      menuItem: "My Meetings",
      link : "/profile?tab=nav-my-meetings-tab"
    },
    {
      key: 6,
      menuItem: "Profile",
      link: "/profile",
    },
    {
      key: 6,
      menuItem: "FCN inMails",
      link: "/inMails",
    },
  ];
  const headerDataAllocators = [
    {
      key: 1,
      menuItem: "Dashboard",
      link: "/dashboard",
    },

    {
      key: 3,
      menuItem: "Search Funds",
      link: "/hedgefunds",
    },

    {
      key: 4,
      menuItem: "News Feed",
      link: "/newsfeed",
    },
    {
      key: 5,
      menuItem: "My Funds",
      link: "/profile?tab=nav-my-funds-tab",
    },
    {
      key: 6,
      menuItem: "Meetings",
      link: "/profile?tab=nav-my-meetings-tab",
    },
    {
      key: 8,
      menuItem: "My Network",
      link : "/my-networks"
    },
    {
      key: 9,
      menuItem: "My Contact",
      link: "/allocator-contacts",
    },
    {
      key: 7,
      menuItem: "Profile",
      link: "/profile",
    },
  ];

  const navigateOnClick = (id) => {
    var alert = alerts.items.find((x) => x.id === id);

    let getNavigation = alertNavigation.find(
      (x) => alert.alertEvent.notificationType === x.key
    );

    var link = getNavigation.value + alert.alertEvent.recordId;

    history.push(link);
  };
  return (
    <>
      <header style={{zIndex : "999"}}>
        <div className="container">
          <div className="header-inner">
            <div className="header-col-left">
              <a href="/" className="logo-box">
                <img
                  src="/assets/images/logo-white.png"
                  className="logo"
                  alt="logo"
                />
              </a>
            </div>
            <div className="header-col-right">
              <div className="header-col-right-mobile-elements">
                <div className="header-navbox">
                  <nav className="header-nav">
                    <ul>
                      {props.navConf === "HedgeFundNav"
                        ? headerDataHedgeFund.map(({ key, menuItem, link }) => (
                            <li
                              key={key}
                              className={
                                window.location.pathname === link && "active"
                              }
                            >
                              <Link to={link}>{menuItem}</Link>
                            </li>
                          ))
                        : headerDataAllocators.map(
                            ({ key, menuItem, link }) => (
                              <li
                                key={key}
                                className={
                                  window.location.pathname === link
                                    ? "active"
                                    : ""
                                }
                              >
                                <Link to={link}>{menuItem}</Link>
                              </li>
                            )
                          )}
                    </ul>
                  </nav>
                </div>
                <div className="profile-widgets">
                  <a href="/chat" className="header-icon">
                    {/* <img src="/assets/images/chat-icon.svg" alt="icon" /> */}
                    <i
                      className="fa fa-comments"
                      aria-hidden="true"
                      style={{ color: "#fff", fontSize: "22px" }}
                    ></i>
                    <span
                      className="badge badge-secondary"
                      style={{
                        position: "absolute",
                        top: "-8px",
                        right: "-10px",
                        backgroundColor: "red",
                        fontSize: "10px"
                      }}
                    >
                      {totalMessages > 0 ? totalMessages : ""}
                    </span>
                  </a>

                  <div className="profile-dropdown">
                    {
                      <button
                        type="button"
                        className="dropdown-toggle bell_dropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{
                          position: "relative",
                        }}
                      >
                        <a href="/chat" className="header-icon">
                          <i
                            className="fa fa-bell"
                            aria-hidden="true"
                            style={{ color: "#fff", fontSize: "22px" }}
                          ></i>
                        </a>
                        <div>
                          <span
                            className="badge badge-secondary"
                            style={{
                              position: "absolute",
                              right: 20,
                              top: -8,
                              backgroundColor: "red",
                              fontSize: "10px",
                            }}
                          >
                            {notificationLength}
                          </span>
                        </div>
                      </button>
                    }

                    <ul className="dropdown-menu dropdown-menu-end hf-dropdown-menu bell-dropdown" style={{ overflowY : "scroll", height : "500px" }}>
                      {alerts.items ? (
                        alerts?.items?.map((alert) => {
                          return (
                            <li onClick={() => setNotificationLength([])}>
                              <a
                                onClick={() => navigateOnClick(alert.id)}
                                className="dropdown-item bell d-flex align-items-center"
                                type="button"
                                href
                              >
                                <span className="blue-back mr-2"></span>
                                <span className="icon mr-2">
                                  <i
                                    className="fa fa-info-circle"
                                    aria-hidden="true"
                                    style={{
                                      fontSize: "22px",
                                      color: "#90afcb",
                                    }}
                                  ></i>
                                </span>
                                <span className="text mx-3">
                                  {alert.alertEvent.title}
                                  <p className="bell-description m-0">
                                    {alert.alertEvent.bodyText}
                                  </p>
                                </span>
                                <span
                                  className="text ms-2"
                                  style={{ width: "40px" }}
                                >
                                  <img
                                    src="/assets/images/empty-avatar.png"
                                    alt="icon"
                                  />
                                </span>
                              </a>
                              <div className="separator"></div>
                            </li>
                          );
                        })
                      ) : (
                        <div className="d-flex justify-content-center align-content-center">
                          <NoDataFound />
                        </div>
                      )}
                    </ul>
                  </div>
                  <div className="profile-avatar mx-sm-3 mr-2">
                    <img src={user.ProfileImage} alt="avatar" />
                  </div>
                  <div className="profile-dropdown">
                    <button
                      type="button"
                      className="dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {user.FullName ? user.FullName : ""}
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end hf-dropdown-menu">
                      <div className="hf-profile-container">
                        <div className="hf-profile-img">
                          <img src={user.ProfileImage} alt="" />
                        </div>
                        <div className="hf-profile-name text-blue">
                          {user.FullName}
                        </div>
                      </div>
                      <div className="separator"></div>
                      {/* <li>
                        <button className="dropdown-item" type="button">
                          Profile
                        </button>
                      </li> */}
                      <li>
                        <button
                          className="dropdown-item"
                          type="button"
                          onClick={() => history.push("/user")}
                        >
                          <span className="icon mr-2">
                            <i className="fa fa-user" aria-hidden="true"></i>
                          </span>
                          <span className="text">User Settings</span>
                        </button>
                      </li>
                      <li>
                        <a
                          href="/calendar"
                          className="dropdown-item"
                          type="button"
                        >
                          <span className="icon mr-2">
                            <i
                              className="fa fa-calendar"
                              aria-hidden="true"
                            ></i>
                          </span>
                          <span className="text">Calendar</span>
                        </a>
                      </li>
                      
                      <li>
                        <a
                          href="/management"
                          className="dropdown-item"
                          type="button"
                        >
                          <span className="icon mr-2">
                            <i className="fa fa-gear" aria-hidden="true"></i>
                          </span>
                          <span className="text">Console</span>
                        </a>
                      </li>
                      <li>
                        <a
                          href="/user-preference"
                          className="dropdown-item"
                          type="button"
                        >
                          <span className="icon mr-2">
                          <i className="fa fa-cogs" aria-hidden="true"></i>
                          </span>
                          <span className="text">User Preference</span>
                        </a>
                      </li>
                      
                      <li>
                        <a
                          className="dropdown-item"
                          type="button"
                          onClick={logout}
                          href="/login"
                        >
                          <span className="icon">
                            <i
                              className="fa fa-sign-out mr-2"
                              aria-hidden="true"
                            ></i>
                          </span>
                          <span className="text">Logout</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="hamburger">
                <span className="line line1"></span>
                <span className="line line2"></span>
                <span className="line line3"></span>
              </div>
            </div>
          </div>
        </div>
      </header>
      <Alert />
      {props.children}
      <footer>
        <div className="container">
        <span> &#169;{year} Financial Capital Network.  All rights reserved. <br />
        Securities services provided through  <a style={{marginTop:"20px"}} href="https://www.pickwickcapitalpartners.com/" target={'_blank'}>Pickwick Capital Partners, </a>, 
        LLC Member <a href="https://www.finra.org/" target="_blank">FINRA</a> and <a href="https://www.sipc.org/" target="_blank">SIPC</a>. </span>
        </div>
      </footer>
    </>
  );
};

export default LayoutWrapper;
